"use strict";function getDeviceProperties$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.getDeviceProperties$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.iot.getDeviceProperties";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.42"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.42"},_a)),exports.getDeviceProperties$=getDeviceProperties$,exports.default=getDeviceProperties$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/iot/getDeviceProperties.js
// module id = 957
// module chunks = 106